module.exports = __webpack_public_path__ + "img/gqcx.f77124b6.png";